export default __webpack_public_path__ + "static/media/me.a2ce7a77.png";